import axios from "axios";
import Cookies from "js-cookie";
import { withApiError, withApiErrorResponse } from "../utils/apiError";

const BASE_URL = process.env.REACT_APP_BASE_BACKEND_API_URL;


// Sakshi - 2026-08-03: DCRC-enabled projects for the Customer Support project
// dropdown (replaces the hardcoded DCRC Elec / Water / RAECO list).
export const getActiveDcrcProjects = async (departmentId) => {
    const token = Cookies.get("accessToken");

    if (departmentId === undefined || departmentId === null || departmentId === "") {
        return [];
    }

    try {
        const response = await axios.get(
            `${BASE_URL}api/v1/project/active-dcrc-projects`,
            {
                params: { departmentId },
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        const value = response.data?.body?.value;
        return Array.isArray(value) ? value : [];
    } catch (error) {
        console.error("Error fetching active DCRC projects:", error);
        throw withApiErrorResponse(error);
    }
};

export const installmentListApi = async (
    accountNo, projectId
) => {
    let responseData;
    try {
        const token = Cookies.get("accessToken");

        const response = await fetch(`${BASE_URL}api/v1/instalment-plan/get?accountNo=${accountNo}&projectId=${projectId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        responseData = await response.json();
    } catch (error) {
        throw new Error(`Error submitting form: ${error.message}`);
    }
    return withApiError(responseData);
  
};

export const CreateInstallment = async (payload) => {
    try {
        const token = Cookies.get("accessToken");

        const response = await axios.post(
            `${BASE_URL}api/v1/instalment-plan/create`,
            payload,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return withApiError(response.data);
    } catch (error) {
        console.error("API Error:", error.response?.data || error.message);
        // Validation failures (too many files, file too big, request over the
        // upload limit) come back as code 601 with the message in body.value --
        // hand those to the caller to show as-is instead of a generic error.
        if (error.response?.data?.header) return error.response.data;
        throw new Error(`Error submitting form: ${error.response?.data?.message || error.message}`);
    }
};


export const CreateEditInstallment = async (payload) => {
    try {
        const token = Cookies.get("accessToken");

        const response = await axios.post(
            `${BASE_URL}api/v1/instalment-plan/create-after-edit`,
            payload,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return withApiError(response.data);
    } catch (error) {
        console.error("API Error:", error.response?.data || error.message);
        if (error.response?.data?.header) return error.response.data;
        throw new Error(`Error submitting form: ${error.response?.data?.message || error.message}`);
    }
};

export const PreviewInstallment = async (accountNo, advancePayment, firstInstallmentDate, numInstallments, remarks,projectId,) => {
    let responseData;
    try {
        const token = Cookies.get("accessToken");

        const response = await fetch(`${BASE_URL}api/v1/instalment-plan/web/preview?accountNo=${accountNo}&advanceAmount=${advancePayment}&firstInstalmentDate=${firstInstallmentDate}&noOfInstalments=${numInstallments}&remarks=${remarks}&projectId=${projectId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        responseData = await response.json();
    } catch (error) {
        throw new Error(`Error submitting form: ${error.message}`);
    }
    console.log(responseData)
    return withApiError(responseData);
};


// create-rc / create-bulk-rc take multipart/form-data: the usual payload as a
// JSON-string `request` part plus one `attachments` part per file (for bulk RC
// the files apply to every account). Content-Type is left to the browser so
// it can add the multipart boundary.
const buildRcFormData = (payload, files = []) => {
    const fd = new FormData();
    fd.append("request", JSON.stringify(payload));
    files.forEach((f) => fd.append("attachments", f));
    return fd;
};

// 601 validation answers on a non-2xx status are still { header, body }
// envelopes; return them so the caller shows body.value as-is.
const readErrorEnvelope = async (data) => {
    try {
        const parsed = data instanceof Blob ? JSON.parse(await data.text()) : data;
        return parsed?.header ? parsed : null;
    } catch {
        return null;
    }
};

export const CreateRc = async (payload, files) => {
    try {
        const token = Cookies.get("accessToken");

        const response = await axios.post(
            `${BASE_URL}api/v1/task/create-rc`,
            buildRcFormData(payload, files),
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        const envelope = await readErrorEnvelope(error.response?.data);
        if (envelope) return envelope;
        console.error("API Error:", error.response?.data || error.message);
        throw new Error(`Error submitting form: ${error.response?.data?.message || error.message}`);
    }
};

export const CreateMultipleRcWithOrg = async (payload, files) => {
    try {
        const token = Cookies.get("accessToken");

        const response = await axios.post(
            `${BASE_URL}api/v1/task/create-bulk-rc`,
            buildRcFormData(payload, files),
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                responseType: "blob",
            }
        );
        const contentType = response.headers["content-type"] || "";

        if (contentType.includes("application/json")) {
            // ✅ Convert Blob to JSON (if API returned JSON)
            const text = await response.data.text();
            return JSON.parse(text);
        }

        const blob = new Blob([response.data], { type: response.headers["content-type"] });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);

        const contentDisposition = response.headers["content-disposition"];
        let fileName = "errorAccountList.xlsx";

        if (contentDisposition) {
            const matches = contentDisposition.match(/filename="?([^"]+)"?/);
            if (matches?.length > 1) {
                fileName = matches[1];
            }
        }

        link.download = fileName;
        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
        return null;
    } catch (error) {
        const envelope = await readErrorEnvelope(error.response?.data);
        if (envelope) return envelope;
        console.error("API Error:", error.response?.data || error.message);
        throw new Error(`Error submitting form: ${error.response?.data?.message || error.message}`);
    }
};

// Same endpoint as CreateMultipleRcWithOrg; kept as an alias for existing imports.
export const CreateMultipleRc = CreateMultipleRcWithOrg;
